<template src="./template.html"></template>
<script>
import iframeLib from 'lib/iframe'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import config from 'src/config'
import EventList from 'components/EventList'
import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'

export default {
  name: 'event-list-widget',
  mixins: [iframeWidgetBaseMixin],
  data() {
    let theme = this.$route.query.theme

    //TODO: should eventually get the venue to update their code
    //
    if (this.$route.query.venueId === '034b0b81fe323e50') {
      //NOTE: hardcode Wall to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === '2da21d662e20fd19') {
      //NOTE: hardcode Vesper to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === '1ec1e43eb02c59ad') {
      //NOTE: hardcode Holy Cow to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === '60d086c11cf0da69') {
      //NOTE: hardcode Grand SF to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === 'efd85112c8b8df9b') {
      //NOTE: hardcode Orgin SF to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === 'ea9a04eadc6a0fd8') {
      //NOTE: hardcode Club Fate to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === 'a96cecfe635136fc') {
      //NOTE: hardcode Birch Hoboken to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === 'f623598b9750fa99') {
      //NOTE: hardcode GEM to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === 'f623598b9750fa99') {
      //NOTE: hardcode GEM to fix their widget colors
      theme = 'theme-dark'
    }

    return {
      venueId: this.$route.query.venueId,
      buttonText: this.$route.query.buttonText,
      eventCount: parseInt(this.$route.query.eventCount, 10),
      buttonBgColor: this.$route.query.buttonBgColor,
      buttonTextColor: this.$route.query.buttonTextColor,
      theme,
    }
  },
  components: {
    EventList,
  },
  methods: {
    onUpdated() {
      this.publishDimensions()

      setTimeout(() => {
        //NOTE : this is dumb, but in vertical mode it wasn't resizing properly
        this.publishDimensions()
      }, 500)
    },
    onEventClicked(event) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.EVENT_CLICKED,
          iframeId: this.iframeId,
          data: {
            event,
            eventId: event.id,
          },
        },
        {
          parent: true,
        }
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/EventList/index.vue